/* ============================================================
   Oferti4ka — собствена иконна система (IC)
   ------------------------------------------------------------
   Правила на сета (спазвай ги при добавяне на нова икона):
   • мрежа 24×24, viewBox "0 0 24 24", живо поле 20×20 (2px поле)
   • щрих 1.6, linecap/linejoin round, fill none, stroke currentColor
   • вътрешни ъгли r=2 (rx="2" по правоъгълниците, дъги r≈2 в пътищата)
   • ЕДИН акцентен детайл под 45° на икона — там, където значи нещо
     (дръжка на лупа, изпускателна чертичка, слънчев лъч, покрив,
     острие на стрелка). Никога „за украса".
   • оптическо изравняване: тесните (стрелки, chevron) се чертаят
     по-широки; плътните (кутия, mail, grid) — по-малки от полето
   • НЯМА плътни икони. Плътността е СЪСТОЯНИЕ (…Filled), не стил.
   Размерът НЕ се пише в стринга — подава се през icon().
   ============================================================ */
(function (root) {
  'use strict';

  var OPEN =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';

  function s(body) { return OPEN + body + '</svg>'; }

  var P = {

    /* ---------- начини на плащане ---------- */
    card: '<rect x="2.5" y="5" width="19" height="14" rx="2"/><path d="M2.5 9.5h19"/><path d="M6 15.5h3.5"/>',
    bank: '<path d="M3 9.6 12 4.2l9 5.4"/><path d="M5.6 9.9v8.1M10 9.9v8.1M14 9.9v8.1M18.4 9.9v8.1"/><path d="M3.2 20.2h17.6"/>',

    /* ---------- навигация и интерфейс ---------- */

    // акцент: дръжката е точно 45°
    search:
      '<circle cx="10.6" cy="10.6" r="6.4"/>' +
      '<path d="M15.3 15.3 20 20"/>',

    // акцент: дръжката на количката е къс 45° щрих
    cart:
      '<path d="M3 3.9 6 6.9"/>' +
      '<path d="M6.1 7h13.3a1.1 1.1 0 0 1 1.07 1.36l-1.3 5.4a2 2 0 0 1-1.94 1.54H9.6a2 2 0 0 1-1.95-1.55L6.1 7z"/>' +
      '<circle cx="10.5" cy="18.7" r="1.45"/>' +
      '<circle cx="17" cy="18.7" r="1.45"/>',

    cartFilled:
      '<path d="M3 3.9 6 6.9"/>' +
      '<path fill="currentColor" d="M6.1 7h13.3a1.1 1.1 0 0 1 1.07 1.36l-1.3 5.4a2 2 0 0 1-1.94 1.54H9.6a2 2 0 0 1-1.95-1.55L6.1 7z"/>' +
      '<circle cx="10.5" cy="18.7" r="1.45" fill="currentColor"/>' +
      '<circle cx="17" cy="18.7" r="1.45" fill="currentColor"/>',

    user:
      '<circle cx="12" cy="8.2" r="3.7"/>' +
      '<path d="M4.7 20.2c.5-4 3.5-6.4 7.3-6.4s6.8 2.4 7.3 6.4"/>',

    userFilled:
      '<circle cx="12" cy="8.2" r="3.7" fill="currentColor"/>' +
      '<path fill="currentColor" d="M4.7 20.2c.5-4 3.5-6.4 7.3-6.4s6.8 2.4 7.3 6.4z"/>',

    heart:
      '<path d="M12 20.2C12 20.2 3.6 15.2 3.6 9.7A4.4 4.4 0 0 1 12 8.1a4.4 4.4 0 0 1 8.4 1.6c0 5.5-8.4 10.5-8.4 10.5z"/>',

    heartFilled:
      '<path fill="currentColor" d="M12 20.2C12 20.2 3.6 15.2 3.6 9.7A4.4 4.4 0 0 1 12 8.1a4.4 4.4 0 0 1 8.4 1.6c0 5.5-8.4 10.5-8.4 10.5z"/>',

    compare:
      '<rect x="4.6" y="10.2" width="5.4" height="10.2" rx="2"/>' +
      '<rect x="14" y="5.4" width="5.4" height="15" rx="2"/>',

    compareFilled:
      '<rect x="4.6" y="10.2" width="5.4" height="10.2" rx="2" fill="currentColor"/>' +
      '<rect x="14" y="5.4" width="5.4" height="15" rx="2" fill="currentColor"/>',

    burger:
      '<path d="M3.6 6.8h16.8M3.6 12h16.8M3.6 17.2h16.8"/>',

    // изцяло 45° — ДНК-то на сета
    close:
      '<path d="M5.8 5.8 18.2 18.2M18.2 5.8 5.8 18.2"/>',

    chevronLeft:  '<path d="M14.6 5.4 8 12l6.6 6.6"/>',
    chevronRight: '<path d="M9.4 5.4 16 12l-6.6 6.6"/>',
    chevronDown:  '<path d="M5.4 9.4 12 16l6.6-6.6"/>',

    // острието е два 45° щриха; стеблото се чертае по-широко (оптика)
    arrowRight:
      '<path d="M3.4 12h16.2"/>' +
      '<path d="M13.4 5.8 19.6 12l-6.2 6.2"/>',

    plus:  '<path d="M12 4.6v14.8M4.6 12h14.8"/>',
    minus: '<path d="M4.4 12h15.2"/>',

    check: '<path d="M4.8 12.4 9.6 17.2 19.2 7.6"/>',

    checkCircle:
      '<circle cx="12" cy="12" r="8.4"/>' +
      '<path d="M8.2 12.2 11 15l5-5"/>',

    info:
      '<circle cx="12" cy="12" r="8.4"/>' +
      '<path d="M12 11.4v5"/>' +
      '<path d="M12 7.9h.01"/>',

    filter:
      '<path d="M3.4 7.6h4.2M13.2 7.6h7.4"/>' +
      '<circle cx="10.4" cy="7.6" r="2.4"/>' +
      '<path d="M3.4 16.4h9M18 16.4h2.6"/>' +
      '<circle cx="15.2" cy="16.4" r="2.4"/>',

    // острието на стрелката = 45°
    sort:
      '<path d="M3.4 6.6h9.6M3.4 12h7M3.4 17.4h4.4"/>' +
      '<path d="M17.8 5.6v13"/>' +
      '<path d="M14.8 15.6 17.8 18.6l3-3"/>',

    grid:
      '<rect x="3.8" y="3.8" width="6.8" height="6.8" rx="2"/>' +
      '<rect x="13.4" y="3.8" width="6.8" height="6.8" rx="2"/>' +
      '<rect x="3.8" y="13.4" width="6.8" height="6.8" rx="2"/>' +
      '<rect x="13.4" y="13.4" width="6.8" height="6.8" rx="2"/>',

    list:
      '<path d="M8.2 6.6h12M8.2 12h12M8.2 17.4h12"/>' +
      '<path d="M4.3 6.6h.01M4.3 12h.01M4.3 17.4h.01"/>',

    star:
      '<path d="M12 3.6 14.53 8.92 20.37 9.68 16.09 13.73 17.17 19.52 12 16.7 6.83 19.52 7.91 13.73 3.63 9.68 9.47 8.92z"/>',

    starFilled:
      '<path fill="currentColor" d="M12 3.6 14.53 8.92 20.37 9.68 16.09 13.73 17.17 19.52 12 16.7 6.83 19.52 7.91 13.73 3.63 9.68 9.47 8.92z"/>',

    starHalf:
      '<path fill="currentColor" stroke="none" d="M12 3.6 9.47 8.92 3.63 9.68 7.91 13.73 6.83 19.52 12 16.7z"/>' +
      '<path d="M12 3.6 14.53 8.92 20.37 9.68 16.09 13.73 17.17 19.52 12 16.7 6.83 19.52 7.91 13.73 3.63 9.68 9.47 8.92z"/>',

    zoom:
      '<circle cx="10.6" cy="10.6" r="6.4"/>' +
      '<path d="M15.3 15.3 20 20"/>' +
      '<path d="M8.2 10.6h4.8M10.6 8.2v4.8"/>',

    phone:
      '<path d="M20.2 16.6v2.4a1.8 1.8 0 0 1-2 1.8 17.6 17.6 0 0 1-7.7-2.7 17.3 17.3 0 0 1-5.3-5.3A17.6 17.6 0 0 1 2.9 5.1a1.8 1.8 0 0 1 1.8-2h2.4a1.8 1.8 0 0 1 1.8 1.55c.1.86.3 1.7.6 2.5a1.8 1.8 0 0 1-.4 1.9L7.45 10.3a14.4 14.4 0 0 0 5.4 5.4l1.15-1.25a1.8 1.8 0 0 1 1.9-.4c.8.3 1.64.5 2.5.6a1.8 1.8 0 0 1 1.55 1.8z"/>',

    mail:
      '<rect x="3.2" y="5.6" width="17.6" height="12.8" rx="2"/>' +
      '<path d="M4.2 6.8 11.3 12.1a1.2 1.2 0 0 0 1.4 0l7.1-5.3"/>',

    pin:
      '<path d="M12 21.2c4.4-4.9 6.6-8.5 6.6-11.1a6.6 6.6 0 1 0-13.2 0c0 2.6 2.2 6.2 6.6 11.1z"/>' +
      '<circle cx="12" cy="10.1" r="2.5"/>',

    clock:
      '<circle cx="12" cy="12" r="8.4"/>' +
      '<path d="M12 7.4V12l3.4 2"/>',

    /* ---------- COD и доставка ---------- */

    // акцент: изпускателна чертичка под 45° зад ремаркето
    truck:
      '<rect x="2.9" y="6.4" width="10.5" height="9.4" rx="2"/>' +
      '<path d="M13.4 9.8h3.5a1.6 1.6 0 0 1 1.13.47l2.2 2.2a1.6 1.6 0 0 1 .47 1.13v1.4a.8.8 0 0 1-.8.8h-6.5"/>' +
      '<circle cx="7.4" cy="18.4" r="1.5"/>' +
      '<circle cx="16.6" cy="18.4" r="1.5"/>' +
      '<path d="M3 20.4 4.8 18.6"/>',

    box:
      '<path d="M12 21.2 3.6 16.6V7.4L12 2.8l8.4 4.6v9.2z"/>' +
      '<path d="M3.6 7.4 12 12l8.4-4.6"/>' +
      '<path d="M12 12v9.2"/>',

    // акцент: капаците са точно 45°
    boxOpen:
      '<path d="M3.8 10.8h16.4v7.6a2 2 0 0 1-2 2H5.8a2 2 0 0 1-2-2z"/>' +
      '<path d="M3.8 10.8 8.3 6.3a1.6 1.6 0 0 1 1.13-.47h1.4"/>' +
      '<path d="M20.2 10.8 15.7 6.3a1.6 1.6 0 0 0-1.13-.47h-1.4"/>',

    banknote:
      '<rect x="3" y="6.2" width="18" height="11.6" rx="2"/>' +
      '<circle cx="12" cy="12" r="2.6"/>' +
      '<path d="M6.6 12h.01M17.4 12h.01"/>',

    // акцент: чавката е два 45° щриха
    shieldCheck:
      '<path d="M12 2.9 19.6 5.8v6.1c0 4.4-3.1 8.2-7.6 9.2-4.5-1-7.6-4.8-7.6-9.2V5.8z"/>' +
      '<path d="M9.1 11.9 11.3 14.1l3.9-3.9"/>',

    // акцент: острието е чист 45°
    returnArrow:
      '<path d="M4 9h11a5.2 5.2 0 0 1 0 10.4H8.6"/>' +
      '<path d="M8.4 4.6 4 9l4.4 4.4"/>',

    warehouse:
      '<path d="M3 10.2 12 5.6l9 4.6"/>' +
      '<path d="M4.6 9.4v11.2h14.8V9.4"/>' +
      '<path d="M8 20.6v-5.2a1.6 1.6 0 0 1 1.6-1.6h4.8a1.6 1.6 0 0 1 1.6 1.6v5.2"/>' +
      '<path d="M8 17.6h8"/>',

    /* ---------- категорийни ---------- */

    // акцент: стеблото на ключа лежи точно на 45°
    tools:
      '<path d="M15.8 3.2a5.2 5.2 0 0 0-6.76 6.76l-5.2 5.2a1.9 1.9 0 0 0 0 2.69l2.31 2.31a1.9 1.9 0 0 0 2.69 0l5.2-5.2a5.2 5.2 0 0 0 6.76-6.76l-3.36 3.36-2.82-.76-.76-2.82z"/>',

    // акцент: жилката на листа е 45°
    garden:
      '<path d="M20.4 3.6C20.4 11.9 15.6 16.7 9.2 16.7A5.6 5.6 0 0 1 3.6 11.1C3.6 4.7 11.4 3.6 20.4 3.6z"/>' +
      '<path d="M17.2 6.8 4.6 19.4"/>',

    // акцент: слънчевият лъч е 45°
    solar:
      '<path d="M3.6 18.4 7 8h10l3.4 10.4z"/>' +
      '<path d="M5.3 13.2h13.4"/>' +
      '<path d="M12 8v10.4"/>' +
      '<path d="M17.6 5.4 20 3"/>',

    camera:
      '<rect x="2.8" y="6.8" width="12.8" height="10.4" rx="2"/>' +
      '<path d="M15.6 13.6 19.6 16.6a.9.9 0 0 0 1.4-.72V8.12a.9.9 0 0 0-1.4-.72L15.6 10.4z"/>',

    // акцент: покривът е точно 45° от двете страни
    home:
      '<path d="M4.6 11.2 12 3.8l7.4 7.4"/>' +
      '<path d="M6.4 9.4v9.6a1.6 1.6 0 0 0 1.6 1.6h8a1.6 1.6 0 0 0 1.6-1.6V9.4"/>' +
      '<path d="M9.8 20.6v-4.4a2.2 2.2 0 0 1 4.4 0v4.4"/>',

    audio:
      '<path d="M4.7 15.8V11.9a7.3 7.3 0 0 1 14.6 0v3.9"/>' +
      '<rect x="2.9" y="14.6" width="3.6" height="5.8" rx="1.8"/>' +
      '<rect x="17.5" y="14.6" width="3.6" height="5.8" rx="1.8"/>',

    car:
      '<path d="M2.9 16.6v-2.1a2 2 0 0 1 1.46-1.93l2.05-.55h11.18l2.05.55A2 2 0 0 1 21.1 14.5v2.1a.9.9 0 0 1-.9.9H3.8a.9.9 0 0 1-.9-.9z"/>' +
      '<path d="M6.4 12 8.7 8.5a2 2 0 0 1 1.67-.9h3.26a2 2 0 0 1 1.67.9l2.3 3.5"/>' +
      '<circle cx="7.3" cy="17.5" r="2.1"/>' +
      '<circle cx="16.7" cy="17.5" r="2.1"/>',

    // акцент: вилката е точно 45°
    motorcycle:
      '<circle cx="5.9" cy="17.3" r="2.9"/>' +
      '<circle cx="18.1" cy="17.3" r="2.9"/>' +
      '<path d="M5.9 17.3 9.4 11.7a1.4 1.4 0 0 1 1.19-.65h3.31l2 2.8 2.3 3.45"/>' +
      '<path d="M14 11.1 16.9 8.2h2.6"/>',

    camping:
      '<path d="M3.6 20.4 13.4 3.8"/>' +
      '<path d="M20.4 20.4 10.6 3.8"/>' +
      '<path d="M15.4 20.4 12 14.4l-3.4 6"/>' +
      '<path d="M3.6 20.4h16.8"/>',

    // акцент: отблясъкът е къс 45° щрих
    health:
      '<path d="M12 3.4c4.2 4.6 6.3 7.9 6.3 10.2a6.3 6.3 0 1 1-12.6 0c0-2.3 2.1-5.6 6.3-10.2z"/>' +
      '<path d="M8.9 15.2 11.5 12.6"/>'
  };

  var IC = {};
  for (var k in P) { if (Object.prototype.hasOwnProperty.call(P, k)) IC[k] = s(P[k]); }

  /* ------------------------------------------------------------
     icon('search', {size:20, cls:'ic-lg'}) -> SVG стринг
     opts:
       size   {number}  ширина и височина в px (по подразбиране 20)
       width  {number}  ако трябва различна ширина
       height {number}
       cls    {string}  CSS клас(ове)
       sw     {number}  щрих, ако трябва оптическа корекция
       label  {string}  ако иконата НЕ е декоративна — маха aria-hidden
                        и слага role="img" + aria-label
       attrs  {string}  суров допълнителен атрибут (data-*, id и т.н.)
     ------------------------------------------------------------ */
  function esc(v) {
    return String(v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function icon(name, opts) {
    var svg = IC[name];
    if (!svg) {
      if (typeof console !== 'undefined' && console.warn) console.warn('icon(): няма икона "' + name + '"');
      return '';
    }
    opts = opts || {};
    var w = opts.width || opts.size || 20;
    var h = opts.height || opts.size || 20;

    if (opts.sw) svg = svg.replace('stroke-width="1.6"', 'stroke-width="' + opts.sw + '"');

    if (opts.label) {
      svg = svg.replace(' aria-hidden="true"', ' role="img" aria-label="' + esc(opts.label) + '"');
    }

    var extra = ' width="' + w + '" height="' + h + '"';
    if (opts.cls) extra += ' class="' + esc(opts.cls) + '"';
    if (opts.attrs) extra += ' ' + opts.attrs;

    return svg.replace('<svg', '<svg' + extra);
  }

  /* всички имена — удобно за preview/тестове */
  icon.names = Object.keys(IC);

  root.IC = IC;
  root.icon = icon;
  if (typeof module !== 'undefined' && module.exports) module.exports = { IC: IC, icon: icon };
})(typeof window !== 'undefined' ? window : globalThis);
